import useAxios from "../../hooks/useAxios";

const useSuperAdminService = () => {
  const axiosList = useAxios();
  const axiosAdd = useAxios();
  const axiosRemove = useAxios();

  const getAllAdminRoles = async () => {
    await axiosList.fetchData({
      url: `/xadmin`,
      method: "GET",
    });
  };

  const addAdminRole = async (employeeId, role) => {
    return await axiosAdd.fetchData({
      url: `/xadmin/add`,
      method: "POST",
      data: { employee_id: employeeId, role },
    });
  };

  const removeAdminRole = async (id) => {
    return await axiosRemove.fetchData({
      url: `/xadmin/destroy/${id}`,
      method: "POST",
    });
  };

  return {
    getAllAdminRoles,
    listLoading: axiosList.loading,
    listResponse: axiosList.response,
    addAdminRole,
    addLoading: axiosAdd.loading,
    removeAdminRole,
    removeLoading: axiosRemove.loading,
  };
};

export default useSuperAdminService;
